import { render, staticRenderFns } from "./_affiliate.vue?vue&type=template&id=7d87db8a&"
import script from "./_affiliate.vue?vue&type=script&lang=js&"
export * from "./_affiliate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports